/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.katiso-brand[_ngcontent-%COMP%] {\n  color: #bd8828; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvWWktWXUvRG9jdW1lbnRzL0FjdHVhbCBEb2N1bWVudHMvS2F0aXNvL2thdGlzby9zcmMvYXBwL2NvbXBvbmVudHMvYWJvdXQtdXMvYWJvdXQtdXMuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvWWktWXUvRG9jdW1lbnRzL0FjdHVhbCBEb2N1bWVudHMvS2F0aXNvL2thdGlzby9zcmMvYXBwL2NvbXBvbmVudHMvYWJvdXQtdXMvYWJvdXQtdXMuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/$$_gendir/app/components/about-us/about-us.component.scss.shim.ngstyle.ts